/**
 * Punto único de registro de los side-effect imports de session reset.
 *
 * Antes estos imports vivían al principio de cada `public-api.ts` (catalog, sync,
 * pos, customers, inventory, team). Eso forzaba a Metro a evaluar toda la cadena
 * de dependencias del barrel sincrónicamente al cargarlo, antes de que los
 * `export` estuvieran disponibles. Cualquier require cycle que pasara por ese
 * barrel se convertía en `TypeError: Cannot read properties of undefined`.
 *
 * Al centralizar los registros acá, los barrels dejan de tener side-effects y
 * los require cycles siguen siendo warnings (Metro los resuelve con lazy getters)
 * pero dejan de crashear en runtime.
 *
 * Este archivo se importa una sola vez en `App.tsx`, antes de que cualquier
 * pantalla o store se renderice. Los handlers se registran en el registry de
 * `shared/ports/sessionResetPort` y se ejecutan cuando ocurre logout, branch
 * switch o account deletion.
 */
import '../catalog/infra/sessionResetRegistration';
import '../sync/infra/sessionResetRegistration';
import '../pos/infra/sessionResetRegistration';
import '../customers/infra/sessionResetRegistration';
import '../inventory/infra/sessionResetRegistration';
import '../team/infra/sessionResetRegistration';
import '../settings/infra/sessionResetRegistration';
import '../shared/ui/appToastSessionReset';
